<template>
  <div class="separator" />
</template>

<script>
/**
 * Separateur SwissLife
 */
export default {
  name: 'SlSeparator'
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .separator {
    background-color: $red;
    height: 0.063rem;
  }

</style>
